import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listSenders } from 'services/SenderService';
import { getLiteral } from 'utils/getLiteral';
import { errorToast } from 'utils/toast';

export default function useCheckInitialSetup() {
    const navigate = useNavigate();
    const [senders, setSenders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoading(true);
        setLoaded(false);
        listSenders()
            .then((items) => {
                setSenders(Array.isArray(items) ? items : []);
                setLoaded(true);
            })
            .catch(() => {
                errorToast({ text: getLiteral('error_generalerror') });
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const hasMinimumSenders = useMemo(() => {
        return senders.length > 0;
    }, [senders]);

    useEffect(() => {
        if (loaded && !hasMinimumSenders) {
            navigate('/campaigns/marketing/initial-setup', { replace: true });
        }
    }, [senders, loaded, hasMinimumSenders, navigate]);

    const isLoading = useMemo(() => {
        return loading && !loaded;
    }, [loading, loaded]);

    return {
        hasMinimumSenders,
        isLoading,
    };
}
